import { render } from "./PersonalLayout.vue?vue&type=template&id=61a0b998&scoped=true"
import script from "./PersonalLayout.vue?vue&type=script&lang=js"
export * from "./PersonalLayout.vue?vue&type=script&lang=js"

import "./PersonalLayout.vue?vue&type=style&index=0&id=61a0b998&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61a0b998"]])

export default __exports__